/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface GMW
 */
export interface GMW {
  /**
   *
   * @type {string}
   * @memberof GMW
   */
  readonly uuid?: string;
  /**
   *
   * @type {string}
   * @memberof GMW
   */
  readonly linkedGmns?: string;
  /**
   *
   * @type {number}
   * @memberof GMW
   */
  readonly nrOfMonitoringTubes?: number;
  /**
   *
   * @type {number}
   * @memberof GMW
   */
  readonly nrOfIntermediateEvents?: number;
  /**
   *
   * @type {Date}
   * @memberof GMW
   */
  readonly created?: Date;
  /**
   *
   * @type {Date}
   * @memberof GMW
   */
  readonly updated?: Date;
  /**
   * Alleen beschikbaar voor de eigenaar van de put.
   * @type {string}
   * @memberof GMW
   */
  internalId?: string | null;
  /**
   *
   * @type {string}
   * @memberof GMW
   */
  broId: string;
  /**
   *
   * @type {string}
   * @memberof GMW
   */
  deliveryAccountableParty?: string | null;
  /**
   *
   * @type {string}
   * @memberof GMW
   */
  qualityRegime?: string | null;
  /**
   *
   * @type {string}
   * @memberof GMW
   */
  wellConstructionDate?: string | null;
  /**
   *
   * @type {string}
   * @memberof GMW
   */
  deliveryContext?: string | null;
  /**
   *
   * @type {string}
   * @memberof GMW
   */
  constructionStandard?: string | null;
  /**
   *
   * @type {string}
   * @memberof GMW
   */
  initialFunction?: string | null;
  /**
   *
   * @type {string}
   * @memberof GMW
   */
  removed?: string | null;
  /**
   *
   * @type {string}
   * @memberof GMW
   */
  groundLevelStable?: string | null;
  /**
   *
   * @type {string}
   * @memberof GMW
   */
  wellStability?: string | null;
  /**
   *
   * @type {string}
   * @memberof GMW
   */
  nitgCode?: string | null;
  /**
   *
   * @type {string}
   * @memberof GMW
   */
  wellCode?: string | null;
  /**
   *
   * @type {string}
   * @memberof GMW
   */
  owner?: string | null;
  /**
   *
   * @type {string}
   * @memberof GMW
   */
  wellHeadProtector?: string | null;
  /**
   *
   * @type {string}
   * @memberof GMW
   */
  deliveredLocation?: string | null;
  /**
   *
   * @type {string}
   * @memberof GMW
   */
  horizontalPositioningMethod?: string | null;
  /**
   *
   * @type {string}
   * @memberof GMW
   */
  localVerticalReferencePoint?: string | null;
  /**
   *
   * @type {string}
   * @memberof GMW
   */
  offset?: string | null;
  /**
   *
   * @type {string}
   * @memberof GMW
   */
  verticalDatum?: string | null;
  /**
   *
   * @type {string}
   * @memberof GMW
   */
  groundLevelPosition?: string | null;
  /**
   *
   * @type {string}
   * @memberof GMW
   */
  groundLevelPositioningMethod?: string | null;
  /**
   *
   * @type {string}
   * @memberof GMW
   */
  standardizedLocation?: string | null;
  /**
   *
   * @type {Date}
   * @memberof GMW
   */
  objectRegistrationTime?: Date | null;
  /**
   *
   * @type {string}
   * @memberof GMW
   */
  registrationStatus?: string | null;
  /**
   *
   * @type {string}
   * @memberof GMW
   */
  dataOwner: string;
}

/**
 * Check if a given object implements the GMW interface.
 */
export function instanceOfGMW(value: object): value is GMW {
  if (
    (!("broId" in (value as Record<string, any>)) &&
      !("bro_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["broId"] === undefined &&
      (value as Record<string, any>)["bro_id"] === undefined)
  )
    return false;
  if (
    (!("dataOwner" in (value as Record<string, any>)) &&
      !("data_owner" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["dataOwner"] === undefined &&
      (value as Record<string, any>)["data_owner"] === undefined)
  )
    return false;
  return true;
}

export function GMWFromJSON(json: any): GMW {
  return GMWFromJSONTyped(json, false);
}

export function GMWFromJSONTyped(json: any, ignoreDiscriminator: boolean): GMW {
  if (json == null) {
    return json;
  }
  return {
    uuid: json["uuid"] == null ? undefined : json["uuid"],
    linkedGmns: json["linked_gmns"] == null ? undefined : json["linked_gmns"],
    nrOfMonitoringTubes:
      json["nr_of_monitoring_tubes"] == null ? undefined : json["nr_of_monitoring_tubes"],
    nrOfIntermediateEvents:
      json["nr_of_intermediate_events"] == null ? undefined : json["nr_of_intermediate_events"],
    created: json["created"] == null ? undefined : new Date(json["created"]),
    updated: json["updated"] == null ? undefined : new Date(json["updated"]),
    internalId:
      json["internal_id"] === undefined
        ? undefined
        : json["internal_id"] === null
        ? null
        : json["internal_id"],
    broId: json["bro_id"],
    deliveryAccountableParty:
      json["delivery_accountable_party"] === undefined
        ? undefined
        : json["delivery_accountable_party"] === null
        ? null
        : json["delivery_accountable_party"],
    qualityRegime:
      json["quality_regime"] === undefined
        ? undefined
        : json["quality_regime"] === null
        ? null
        : json["quality_regime"],
    wellConstructionDate:
      json["well_construction_date"] === undefined
        ? undefined
        : json["well_construction_date"] === null
        ? null
        : json["well_construction_date"],
    deliveryContext:
      json["delivery_context"] === undefined
        ? undefined
        : json["delivery_context"] === null
        ? null
        : json["delivery_context"],
    constructionStandard:
      json["construction_standard"] === undefined
        ? undefined
        : json["construction_standard"] === null
        ? null
        : json["construction_standard"],
    initialFunction:
      json["initial_function"] === undefined
        ? undefined
        : json["initial_function"] === null
        ? null
        : json["initial_function"],
    removed:
      json["removed"] === undefined ? undefined : json["removed"] === null ? null : json["removed"],
    groundLevelStable:
      json["ground_level_stable"] === undefined
        ? undefined
        : json["ground_level_stable"] === null
        ? null
        : json["ground_level_stable"],
    wellStability:
      json["well_stability"] === undefined
        ? undefined
        : json["well_stability"] === null
        ? null
        : json["well_stability"],
    nitgCode:
      json["nitg_code"] === undefined
        ? undefined
        : json["nitg_code"] === null
        ? null
        : json["nitg_code"],
    wellCode:
      json["well_code"] === undefined
        ? undefined
        : json["well_code"] === null
        ? null
        : json["well_code"],
    owner: json["owner"] === undefined ? undefined : json["owner"] === null ? null : json["owner"],
    wellHeadProtector:
      json["well_head_protector"] === undefined
        ? undefined
        : json["well_head_protector"] === null
        ? null
        : json["well_head_protector"],
    deliveredLocation:
      json["delivered_location"] === undefined
        ? undefined
        : json["delivered_location"] === null
        ? null
        : json["delivered_location"],
    horizontalPositioningMethod:
      json["horizontal_positioning_method"] === undefined
        ? undefined
        : json["horizontal_positioning_method"] === null
        ? null
        : json["horizontal_positioning_method"],
    localVerticalReferencePoint:
      json["local_vertical_reference_point"] === undefined
        ? undefined
        : json["local_vertical_reference_point"] === null
        ? null
        : json["local_vertical_reference_point"],
    offset:
      json["offset"] === undefined ? undefined : json["offset"] === null ? null : json["offset"],
    verticalDatum:
      json["vertical_datum"] === undefined
        ? undefined
        : json["vertical_datum"] === null
        ? null
        : json["vertical_datum"],
    groundLevelPosition:
      json["ground_level_position"] === undefined
        ? undefined
        : json["ground_level_position"] === null
        ? null
        : json["ground_level_position"],
    groundLevelPositioningMethod:
      json["ground_level_positioning_method"] === undefined
        ? undefined
        : json["ground_level_positioning_method"] === null
        ? null
        : json["ground_level_positioning_method"],
    standardizedLocation:
      json["standardized_location"] === undefined
        ? undefined
        : json["standardized_location"] === null
        ? null
        : json["standardized_location"],
    objectRegistrationTime:
      json["object_registration_time"] === undefined
        ? undefined
        : json["object_registration_time"] === null
        ? null
        : new Date(json["object_registration_time"]),
    registrationStatus:
      json["registration_status"] === undefined
        ? undefined
        : json["registration_status"] === null
        ? null
        : json["registration_status"],
    dataOwner: json["data_owner"],
  };
}

export function GMWToJSON(json: any): GMW {
  return GMWToJSONTyped(json, false);
}

export function GMWToJSONTyped(
  value?: Omit<
    GMW,
    | "uuid"
    | "linked_gmns"
    | "nr_of_monitoring_tubes"
    | "nr_of_intermediate_events"
    | "created"
    | "updated"
  > | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    internal_id: value["internalId"],
    bro_id: value["broId"],
    delivery_accountable_party: value["deliveryAccountableParty"],
    quality_regime: value["qualityRegime"],
    well_construction_date: value["wellConstructionDate"],
    delivery_context: value["deliveryContext"],
    construction_standard: value["constructionStandard"],
    initial_function: value["initialFunction"],
    removed: value["removed"],
    ground_level_stable: value["groundLevelStable"],
    well_stability: value["wellStability"],
    nitg_code: value["nitgCode"],
    well_code: value["wellCode"],
    owner: value["owner"],
    well_head_protector: value["wellHeadProtector"],
    delivered_location: value["deliveredLocation"],
    horizontal_positioning_method: value["horizontalPositioningMethod"],
    local_vertical_reference_point: value["localVerticalReferencePoint"],
    offset: value["offset"],
    vertical_datum: value["verticalDatum"],
    ground_level_position: value["groundLevelPosition"],
    ground_level_positioning_method: value["groundLevelPositioningMethod"],
    standardized_location: value["standardizedLocation"],
    object_registration_time:
      value["objectRegistrationTime"] == null
        ? value["objectRegistrationTime"]
        : value["objectRegistrationTime"].toISOString(),
    registration_status: value["registrationStatus"],
    data_owner: value["dataOwner"],
  };
}
